import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const BankActivationButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="p-5 fixed w-full border-t z-[99]  bg-white border-gray--7 bottom-0 max-w-3xl  ">
      <Button
        block
        className={`default-button-large min-h-[46px] justify-center items-center`}
        onClick={() => navigate("/card")}
      >
        {t("close")}
      </Button>
    </div>
  );
};

export default BankActivationButton;
